<template>
  <div class="mainContainer">
    <div class="waitContain" v-if="govUserData.is_government_user === 0">
      <div class="textContain">
        <div class="title">政务号</div>
        <div class="label">功能说明</div>
        <div class="intro">
          集信息发布、用户互动、服务查询于一体的政务综合窗口，助力政务机关开展“可管理、可触达、可服务”的移动端政务新媒体和数字政务服务建设。
        </div>
        <div class="label">开通条件</div>
        <div class="intro">
          在顶端新闻平台认证为“政府机构”“其他组织”“媒体认证”类型的顶端号
        </div>
        <div class="addBtn" @click="contactVisible = true">立即添加</div>
      </div>
      <img src="../../assets/govAffairs/example.png" class="exampleImg" />

      <el-dialog title="" :visible.sync="contactVisible" width="420px" class="contactContainer">
        <img src="../../assets/govAffairs/contact.png" class="contactImg" />
        <div class="contactText">您的专属政务客服</div>
        <div class="contactText">
          <div class="contactLabel">联系方式：</div>
          <div class="contactTels">
            18237108378<br />18625523656<br />15516926071
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="submitBtn" @click="contactVisible = false">取 消</div>
          <div class="submitBtn" type="primary" @click="contactVisible = false">
            确 定
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="setContain" v-if="govUserData.is_government_user === 1">
      <div class="userInfoContain">
        <div class="actionContain">
          <div class="title">主页管理</div>
          <div class="statusContain" v-if="govUserData.status == 2 || rankNames.length > 0">
            <div class="statusShowContain">
              <img src="../../assets/govAffairs/notice.png" class="noticeImg" />
              <div class="userStatusText" v-if="govUserData.status == 2">
                当前您的政务号主页已被下架
              </div>
              <div class="userStatusText" v-else-if="rankNames.length > 0" style="cursor: pointer"
                @click="rankShow = true">
                恭喜你成功入选顶端政务榜单
              </div>
            </div>
            <div class="upBtn" @click="setGovernmentUserStatus()">上架</div>
          </div>
        </div>
        <div class="userInfoInnerContain">
          <div class="userBaseInfoContain">
            <div class="infosContain">
              <div class="label">用户名称：</div>
              <div class="infoText">{{ govUserData.u_nickname }}</div>
            </div>
            <div class="infosContain">
              <div class="label">用户头像：</div>
              <img :src="govUserData.u_avatar" class="avatarImg" />
            </div>
            <div class="infosContain">
              <div class="label">用户简介：</div>
              <div class="infoText">{{ govUserData.u_description }}</div>
            </div>
          </div>
          <div class="homeBgContainer">
            <div class="userInfoTitleContain">
              <p class="userInfoTitle">品牌封面图：</p>
            </div>
            <div class="homeBgContain">
              <el-upload drag action="no" accept="image/*" :before-upload="onBeforeUpload" :http-request="uploadFn"
                class="uploadElemBox">
                <img :src="govUserData.cover_url ||
                  require('../../assets/script/uploadC.png')
                  " class="homeBg" />
              </el-upload>
              <img src="../../assets/imgDelete.png" class="imgDelete" @click="imgDelete()" />
            </div>
            <div class="homeBgAlert">
              此图主要用于企业品牌搜索结果的展示
              <br />仅支持jpg、png、jpeg格式图片，图片尺寸16:9
              大小不能大于5M。
            </div>
            <div class="bgAuditStatus" v-if="govUserData.cover_audit_status != 1">{{ govUserData.cover_audit_status == 2
              ?
              "素材审核未通过，请优化内容后重新发起申请。" : "素材审核中..." }}
            </div>
          </div>
          <div class="contactContain">
            <img src="../../assets/govAffairs/contact.png" class="contactImg" />
            <div class="contactText">您的专属政务客服</div>
            <div class="contactText">
              <div class="contactLabel">联系方式：</div>
              <div class="contactTels">
                18237108378<br />18625523656<br />15516926071
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contentSetContain">
        <div class="contentSetTitle">自定义菜单</div>
        <div class="contentSetAlert">
          最多支持创建10个自定义菜单（含默认菜单）
        </div>
        <div class="contentSetInnerContain">
          <div class="menuContain">
            <div class="addMenuBtn" @click="openMenuEdit()">
              <img src="../../assets/govAffairs/add.png" class="addMenuImg" />
              <div class="addMenuText">添加快捷菜单</div>
            </div>
            <draggable class="menusContain publicScroll" v-model="menuList" @start="onDragStart" @end="onDragEnd">
              <div class="menuItem" v-for="(item, index) in menuList" :key="index"
                :class="{ active: menuIndex === index }" @click="menuClick(index)">
                <img src="../../assets/govAffairs/setR.png" class="setImg" v-if="menuIndex == index" />
                <img src="../../assets/govAffairs/set.png" class="setImg" v-else />
                <div class="menuName">{{ item.name }}</div>
                <div class="menuEditBtn" @click.stop="openMenuEdit(item)">
                  编辑
                </div>
                <div class="menuDelBtn" :class="{ acytiveText: menuIndex == index }"
                  @click.stop="delGovernmentMenu(index)">
                  删除
                </div>
              </div>
            </draggable>
          </div>
          <div class="menuContentContain" v-if="menuList.length">
            <div class="menuContentTitleContain">
              <div class="menuContentTitle">
                菜单类型：{{ menuList[menuIndex].jump_type | getTypeName }}
              </div>
              <div class="addNewsBtn" v-if="menuList[menuIndex].jump_type == 1" @click="openVideos()">
                <img src="../../assets/govAffairs/add.png" class="addNewsImg" />
                <div class="addNewsText">添加稿件</div>
              </div>
            </div>
            <div class="paramsContain" v-show="menuList[menuIndex].jump_type > 1">
              <div class="paramInfo">
                <span class="paramInfoLabel">跳转地址：</span>{{ menuList[menuIndex].jump_params.jump_id }}
              </div>
              <div class="paramInfo" v-if="menuList[menuIndex].jump_params.jump_app_id">
                <span class="paramInfoLabel">APP ID：</span>{{ menuList[menuIndex].jump_params.jump_app_id }}
              </div>
              <div class="paramInfo" v-if="menuList[menuIndex].jump_params.jump_app_query">
                <span class="paramInfoLabel">QUERY：</span>{{ menuList[menuIndex].jump_params.jump_app_query }}
              </div>
            </div>
            <draggable class="newsContain publicScroll" v-model="collectionList" @end="onNewsDragEnd"
              v-show="menuList[menuIndex].jump_type == 1">
              <div class="newsItem" v-for="(item, index) in collectionList" :key="index">
                <img src="../../assets/govAffairs/shift.png" class="shiftImg" />
                <div class="bgContainer">
                  <div class="cover-container" v-if="item.n_cover_url.length > 0">
                    <el-image class="cover" fit="cover" :src="item.n_cover_url[0]"
                      :preview-src-list="item.n_cover_url" />
                  </div>
                  <div class="info-box">
                    <div class="titleContainer">
                      <p class="title">
                        {{ item.n_title }}
                      </p>
                      <p class="create-time">{{ item.n_create_time }}</p>
                    </div>
                    <div class="action-bar">
                      <!-- <div class="countInfo">展现 {{ item.watch_num }}</div>
                      <div class="countInfo">评论 {{ item.comment_num }}</div> -->
                      <div class="menuNewsDelBtn" @click="delMenuNews(index)">
                        删除
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>

      <el-dialog :title="(editMenuObj.id ? '编辑' : '添加') + '快捷菜单'" :visible.sync="editMenuVisible" width="840px"
        class="editMenuContainer">
        <div class="editMenuInnerContain">
          <div class="editItem">
            <div class="label"><span class="require">*</span>名称：</div>
            <el-input placeholder="请输入菜单名称" v-model="editMenuObj.name" maxlength="10">
            </el-input>
          </div>
          <div class="editItem">
            <div class="label"><span class="require">*</span>菜单类型：</div>
            <el-radio-group v-model="editMenuObj.jump_type">
              <el-radio :label="1">稿件列表</el-radio>
              <el-radio :label="2">跳转网页</el-radio>
              <el-radio :label="3">跳转微信小程序</el-radio>
              <el-radio :label="4">跳转支付宝小程序</el-radio>
            </el-radio-group>
          </div>
          <div class="editItem" v-if="editMenuObj.jump_type > 1">
            <div class="label"><span class="require">*</span>跳转地址：</div>
            <el-input placeholder="请输入" v-model="editMenuObj.jump_id">
            </el-input>
          </div>
          <div class="editItem" v-if="editMenuObj.jump_type > 2">
            <div class="label"><span class="require">*</span>APP ID：</div>
            <el-input placeholder="请输入" v-model="editMenuObj.jump_app_id">
            </el-input>
          </div>
          <div class="editItem" v-if="editMenuObj.jump_type == 4">
            <div class="label"><span class="require">*</span>QUERY：</div>
            <el-input placeholder="请输入" v-model="editMenuObj.jump_app_query">
            </el-input>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="submitBtn" @click="editMenuVisible = false">取 消</div>
          <div class="submitBtn" type="primary" @click="setGovernmentMenu()">
            确 定
          </div>
        </div>
      </el-dialog>

      <el-dialog title="添加内容" :visible.sync="collectionAddVisible" width="840px" top="5vh"
        class="collectionAddContainer" :close-on-click-modal="false">
        <el-input v-model="collectionAddKeyword" placeholder="请输入关键词" clearable class="collectionAddKeyword"
          @keyup.enter.native="getVideoList(1)" @clear="clearVideoList()"></el-input>
        <el-button type="primary" @click="getVideoList(1)">查 询</el-button>
        <div class="videoCollectContainer publicScroll" v-show="collectionAddList.length">
          <div v-for="(item, index) in collectionAddList" :key="index" class="scriptListItem">
            <el-checkbox v-model="item.checked" @change="(checked) => handleCheckVideo(checked, item)"></el-checkbox>
            <div class="bgContainer">
              <div class="cover-container" v-if="item.n_cover_url.length > 0">
                <el-image class="cover" fit="cover" :src="item.n_cover_url[0]" :preview-src-list="item.n_cover_url" />
              </div>
              <div class="info-box">
                <div class="titleContainer">
                  <p class="title" @click="toDetail(item)">
                    {{ item.n_title }}
                  </p>
                  <p class="create-time">{{ item.n_create_time }}</p>
                </div>
                <div class="action-bar">
                  <div class="countInfo">展现 {{ item.watch_num }}</div>
                  <div class="countInfo">评论 {{ item.comment_num }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="searchNoDataContainer" v-if="collectionAddList.length == 0">
          <img src="../../assets/script/no.png" class="noDataImg" />
          <p class="noDataText">暂无数据</p>
        </div>
        <el-pagination background :current-page="currentPage" :page-size="pageSize"
          layout="total, prev, pager, next, jumper" :total="total" @current-change="handleCurrentChange" />
        <br />
        <div slot="footer" class="dialog-footer">
          <el-button @click="collectionAddVisible = false">取 消</el-button>
          <el-button type="primary" @click="addVideosFn">确 定</el-button>
        </div>
      </el-dialog>

      <div class="rankNoticeContain" v-if="rankShow" @click="rankShow = false">
        <div class="rankNotice" @click.stop="">
          <img src="../../assets/govAffairs/close.png" class="closeImg" @click="rankShow = false" />
          <div class="rankNameContain">
            <div v-for="(item, index) in rankNames" :key="index" class="rankItem">
              <img src="../../assets/govAffairs/left.png" class="nameImg" />
              <div class="rankName">{{ item }}</div>
              <img src="../../assets/govAffairs/right.png" class="nameImg" />
            </div>
          </div>
          <img src="../../assets/govAffairs/prod.png" class="codeImg" v-if="isProd" />
          <img src="../../assets/govAffairs/dev.png" class="codeImg" v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { SWNEWS_HOST } from "../../constants/apiHosts";
import { HS_upload } from "./../../utils/huoshanUpload";

export default {
  data() {
    return {
      govUserData: {
        is_government_user: -1,
      },
      contactVisible: false,
      menuList: [],
      menuIndex: 0,
      idNow: "",
      editMenuObj: {
        name: "",
        jump_type: 1, //1稿件 2外链 3微信小程序 4支付宝小程序
        jump_id: "", //地址
        jump_app_id: "",
        jump_app_query: "", //支付宝小程序
        id: "",
      },
      editMenuVisible: false,
      collectionList: [],
      collectionAddVisible: false,
      collectionAddList: [],
      pageSize: 20,
      currentPage: 1,
      total: 1,
      collectionAddKeyword: "",
      currentAddKeyword: "",
      collectionAddChecks: [],
      menuNewsPage: 1,
      menuNewsSize: 10,
      menuNewsIsAll: false,
      rankShow: false,
      rankNames: [],
      isProd: false,
    };
  },
  components: {
    draggable,
  },
  filters: {
    getTypeName: function (type) {
      let text = "稿件列表";
      switch (type) {
        case 2:
          text = "跳转网页";
          break;
        case 3:
          text = "跳转微信小程序";
          break;
        case 4:
          text = "跳转支付宝小程序";
          break;
      }
      return text;
    },
  },
  created() {
    this.getCreatorGovernmentUser();
    this.getGovernmentMenuList();

    if (window.location.href.indexOf("topnews.cn") > -1) {
      this.isProd = true;
    }
  },
  mounted() { },
  methods: {
    getCreatorGovernmentUser() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/government/getCreatorGovernmentUser`, {})
        .then((res) => {
          if (res.data.code == 0) {
            this.govUserData = res.data.data;
            if (this.govUserData.is_government_user == 1) {
              this.getUserGovTopInfo();
            }

            this.$nextTick(() => {
              let _this = this;
              setTimeout(() => {
                let newsContain =
                  document.getElementsByClassName("newsContain")[0];
                if (!newsContain) {
                  return;
                }
                newsContain.addEventListener("scroll", function () {
                  if (
                    newsContain.scrollTop + newsContain.clientHeight >=
                    newsContain.scrollHeight &&
                    !_this.menuNewsIsAll &&
                    newsContain.scrollTop > 0
                  ) {
                    _this.menuNewsPage++;
                    _this.getMenuNewsList();
                  }
                });
              }, 500);
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    setGovernmentUserStatus() {
      this.$axios
        .post(`${SWNEWS_HOST}/api/government/setGovernmentUserStatus`, {})
        .then((res) => {
          if (res.data.code == 0) {
            this.getCreatorGovernmentUser();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getUserGovTopInfo() {
      this.$axios
        .post(`${SWNEWS_HOST}/api/govTop/getUserGovTopInfo`, {})
        .then((res) => {
          if (res.data.code == 0) {
            this.rankNames = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getGovernmentMenuList() {
      this.$axios
        .post(`${SWNEWS_HOST}/api/government/getGovernmentMenuList`, {})
        .then((res) => {
          if (res.data.code == 0) {
            this.menuList = res.data.data;

            if (
              this.menuList[this.menuIndex] &&
              this.menuList[this.menuIndex].jump_type == 1
            ) {
              this.collectionList = [];
              this.menuNewsPage = 1;
              this.menuNewsIsAll = false;
              this.getMenuNewsList();
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    onDragStart() {
      this.idNow = this.menuList[this.menuIndex].id;
    },
    onDragEnd(event) {
      const { newIndex, oldIndex } = event;
      const movedItem = this.menuList[newIndex];
      const params = {
        id: movedItem.id,
        prev_id:
          newIndex > 0
            ? this.menuList[newIndex - 1]
              ? this.menuList[newIndex - 1].id
              : ""
            : "",
        next_id:
          newIndex < this.menuList.length - 1
            ? this.menuList[newIndex + 1]
              ? this.menuList[newIndex + 1].id
              : ""
            : "",
      };

      this.$axios
        .post(`${SWNEWS_HOST}/api/government/sortGovernmentMenu`, params)
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: "success",
              message: "排序成功!",
            });

            this.menuIndex = this.menuList.findIndex(
              (item) => item.id == this.idNow
            );
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    menuClick(index) {
      this.menuIndex = index;

      this.collectionList = [];
      this.menuNewsPage = 1;
      this.menuNewsIsAll = false;

      if (this.menuList[index].jump_type == 1) {
        this.getMenuNewsList();
      }
    },
    openMenuEdit(editMenuObj) {
      if (editMenuObj) {
        this.editMenuObj = {
          name: editMenuObj.name,
          jump_type: editMenuObj.jump_type, //1稿件 2外链 3微信小程序 4支付宝小程序
          jump_id: editMenuObj.jump_params.jump_id, //地址
          jump_app_id: editMenuObj.jump_params.jump_app_id,
          jump_app_query: editMenuObj.jump_params.jump_app_query, //支付宝小程序
          id: editMenuObj.id,
        };
      } else if (this.menuList.length >= 10) {
        this.$message.warning("最多支持创建10个自定义菜单");
        return;
      } else {
        this.editMenuObj = {
          name: "",
          jump_type: 1, //1稿件 2外链 3微信小程序 4支付宝小程序
          jump_id: "", //地址
          jump_app_id: "",
          jump_app_query: "", //支付宝小程序
          id: "",
        };
      }
      this.editMenuVisible = true;
    },
    setGovernmentMenu() {
      if (!this.editMenuObj.name) {
        this.$message.warning("请输入菜单名称");
        return;
      } else if (this.editMenuObj.jump_type > 1 && !this.editMenuObj.jump_id) {
        this.$message.warning("请输入跳转地址");
        return;
      } else if (
        this.editMenuObj.jump_type > 2 &&
        !this.editMenuObj.jump_app_id
      ) {
        this.$message.warning("请输入APP ID");
        return;
      } else if (
        this.editMenuObj.jump_type == 4 &&
        !this.editMenuObj.jump_app_query
      ) {
        this.$message.warning("请输入QUERY");
        return;
      }

      if (!this.editMenuObj.jump_id) {
        delete this.editMenuObj.jump_id;
      }
      if (!this.editMenuObj.jump_app_id) {
        delete this.editMenuObj.jump_app_id;
      }
      if (!this.editMenuObj.jump_app_query) {
        delete this.editMenuObj.jump_app_query;
      }
      if (!this.editMenuObj.id) {
        delete this.editMenuObj.id;
      }

      this.$axios
        .post(
          `${SWNEWS_HOST}/api/government/setGovernmentMenu`,
          this.editMenuObj
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.getGovernmentMenuList();

            this.$message({
              type: "success",
              message: `${this.editMenuObj.id ? "编辑" : "添加"}成功!`,
            });
            this.editMenuVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    delGovernmentMenu(index) {
      this.$confirm("确定要删除该菜单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.idNow = this.menuList[this.menuIndex].id;

          this.$axios
            .post(`${SWNEWS_HOST}/api/government/delGovernmentMenu`, {
              id: this.menuList[index].id,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.menuList.splice(index, 1);

                this.menuIndex = this.menuList.findIndex(
                  (item) => item.id == this.idNow
                );
                if (this.menuIndex == -1) {
                  this.menuIndex = 0;
                }

                if (this.menuList[this.menuIndex].jump_type == 1) {
                  this.collectionList = [];
                  this.menuNewsPage = 1;
                  this.menuNewsIsAll = false;
                  this.getMenuNewsList();
                }

                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => { });
    },
    getMenuNewsList() {
      this.$axios
        .post(`${SWNEWS_HOST}/api/government/getMenuNewsList`, {
          menu_id: this.menuList[this.menuIndex].id,
          page: this.menuNewsPage,
          pageSize: this.menuNewsSize,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.collectionList = this.collectionList.concat(
              res.data.data.returnData
            );

            if (res.data.data.returnData.length < this.menuNewsSize) {
              this.menuNewsIsAll = true;
            } else {
              this.menuNewsIsAll = false;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    openVideos() {
      this.currentAddKeyword = "";
      this.collectionAddKeyword = "";
      this.currentPage = 1;
      this.collectionAddChecks = JSON.parse(
        JSON.stringify(this.collectionList)
      );
      this.getVideoList();
      this.collectionAddVisible = true;

      this.$nextTick(() => {
        document.getElementsByClassName(
          "videoCollectContainer"
        )[0].scrollTop = 0;
      });
    },
    clearVideoList() {
      this.collectionAddKeyword = "";
      this.getVideoList(1);
    },
    getVideoList(isSearch) {
      if (isSearch) {
        this.currentAddKeyword = this.collectionAddKeyword;
        this.currentPage = 1;
      }
      this.$axios
        .get(
          `${SWNEWS_HOST}/api/user/newsList?page=${this.currentPage}&size=${this.pageSize}&title=${this.currentAddKeyword}&tab=7&type=0`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.returnData.forEach((item) => {
              if (this.checkCollection(item.n_id) > -1) {
                //item.checked = true;
                item.checked = false;
              } else {
                item.checked = false;
              }
              item.indexChange = "";
              item.visible = false;
            });
            this.collectionAddList = res.data.data.returnData;
            this.total = res.data.data.count;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getVideoList();

      document.getElementsByClassName("videoCollectContainer")[0].scrollTop = 0;
    },
    handleCheckVideo(val, item) {
      if (val) {
        if (this.checkCollection(item.n_id) < 0) {
          this.collectionAddChecks.unshift(item);
        }
      } else {
        if (this.checkCollection(item.n_id) > -1) {
          this.collectionAddChecks.splice(this.checkCollection(item.n_id), 1);
        }
      }
    },
    checkCollection(itemId) {
      let itemIndex = -1;
      this.collectionAddChecks.forEach((item, index) => {
        if (item.n_id == itemId) {
          itemIndex = index;
        }
      });
      return itemIndex;
    },
    addVideosFn() {
      let n_ids = [];
      if (!this.collectionAddChecks.length) {
        return;
      } else {
        this.collectionAddChecks.forEach((item) => {
          n_ids.push(item.n_id);
        });
      }

      this.$axios
        .post(`${SWNEWS_HOST}/api/government/setMenuNews`, {
          menu_id: this.menuList[this.menuIndex].id,
          n_id: n_ids.join(","),
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.collectionList = [];
            this.menuNewsPage = 1;
            this.menuNewsIsAll = false;
            this.getMenuNewsList();

            this.$message({
              type: "success",
              message: "修改成功!",
            });

            this.collectionAddVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toDetail(item) {
      let routeUrl = this.$router.resolve({
        path: "/scriptDetail",
        query: {
          scriptId: item.nm_id,
          isMine: 1,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    onNewsDragEnd(event) {
      const { newIndex, oldIndex } = event;
      const movedItem = this.collectionList[newIndex];
      const params = {
        id: movedItem.id,
        prev_id:
          newIndex > 0
            ? this.collectionList[newIndex - 1]
              ? this.collectionList[newIndex - 1].id
              : ""
            : "",
        next_id:
          newIndex < this.collectionList.length - 1
            ? this.collectionList[newIndex + 1]
              ? this.collectionList[newIndex + 1].id
              : ""
            : "",
      };

      this.$axios
        .post(`${SWNEWS_HOST}/api/government/sortMenuNews`, params)
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: "success",
              message: "排序成功!",
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    delMenuNews(index) {
      this.$confirm("确定要删除该稿件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${SWNEWS_HOST}/api/government/delMenuNews`, {
              id: this.collectionList[index].id,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.collectionList.splice(index, 1);

                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => { });
    },
    onBeforeUpload(file) {
      if (
        (this.infoTypeIndex == 0 && this.enterpriseData.audit_avatar) ||
        (this.infoTypeIndex == 1 &&
          this.enterpriseData.showinfo_audit_status == 0)
      ) {
        this.$message.error("审核中，不可重复提交！");
        return false;
      }

      const size = this.infoTypeIndex == 0 ? 2 : 5;
      const isIMAGE = file.type.indexOf("image/") >= 0;
      const isLt1M = file.size / 1024 / 1024 < size;

      if (!isIMAGE) {
        this.$message.error("上传文件只能是图片格式！");
        return false;
      } else if (!isLt1M) {
        this.$message.error(`上传文件大小不能超过${size}MB！`);
      } else {
        return true;
      }
    },
    uploadFn(val) {
      HS_upload(
        val.file,
        (data) => {
          this.setGovernmentUserCoverUrl(data.url);
        },
        (error) => {
          console.log("error:" + error);
        },
        (processPercent) => {
          console.log("processPercent:" + processPercent);
        }
      );
    },
    imgDelete() {
      if (this.govUserData.showinfo_audit_status == 0) {
        this.$message.error("审核中，不可修改！");
      } else {
        this.govUserData.cover_url = "";
      }
    },
    setGovernmentUserCoverUrl(cover_url) {
      this.$axios
        .post(`${SWNEWS_HOST}/api/government/setGovernmentUserCoverUrl`, {
          cover_url: cover_url
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: "success",
              message: "上传成功,等待审核通过后生效!",
            });
            this.$set(this.govUserData, "cover_url", cover_url);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.mainContainer {
  min-width: 1000px;
  min-height: 100%;

  .waitContain {
    border-radius: 8px;
    background-color: #fff;
    padding: 10vh 59px 100px 99px;
    display: flex;
    height: calc(100vh - 100px);

    .textContain {
      flex: 1;
      padding-right: 96px;

      .title {
        color: #f32432;
        font-family: "PingFang SC";
        font-size: 48px;
        font-weight: 600;
        line-height: 110px;
      }

      .label {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 18px;
        font-weight: 500;
        line-height: 25px;
        margin-top: 23px;
      }

      .intro {
        color: #666666;
        text-align: justify;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin-top: 16px;
      }

      .addBtn {
        width: 112px;
        line-height: 36px;
        border-radius: 4px;
        background: #f32432;
        color: #ffffff;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        margin-top: 74px;
      }
    }

    .exampleImg {
      width: 58%;
      height: fit-content;
    }

    /deep/.contactContainer {
      .el-dialog__body {
        padding-bottom: 32px;
        padding-top: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .contactImg {
          width: 64px;
          margin: 0 auto 17px auto;
        }

        .contactText {
          color: #333333;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          display: flex;
        }
      }

      .submitBtn {
        width: 80px;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        border-radius: 4px;
        color: #333;
        line-height: 36px;
        display: inline-block;
        margin-left: 12px;
      }

      .submitBtn[type="primary"] {
        width: 80px;
        background-color: #ea0e0e;
        border-color: #ea0e0e;
        color: #fff;
      }

      .dialog-footer {
        display: flex;
        justify-content: center;
      }
    }
  }

  .setContain {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 100px);

    .userInfoContain {
      width: 100%;
      border-radius: 8px;
      background: #fff;
      padding: 0 32px 20px 32px;

      .actionContain {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #eeeeee;

        .title {
          color: #333333;
          font-family: "PingFang SC";
          font-size: 18px;
          font-weight: 500;
          line-height: 60px;
        }

        .statusContain {
          display: flex;
          align-items: center;

          .statusShowContain {
            display: flex;
            align-items: center;

            .noticeImg {
              height: 28px;
              margin-right: 8px;
            }

            .userStatusText {
              color: #ff7d00;
              font-family: "PingFang SC";
              font-size: 12px;
              font-weight: 400;
            }
          }

          .upBtn {
            width: 112px;
            border-radius: 4px;
            background: #f32432;
            color: #ffffff;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 500;
            line-height: 36px;
            margin-left: 32px;
            cursor: pointer;
          }
        }
      }

      .userInfoInnerContain {
        padding-top: 20px;
        display: flex;
        justify-content: space-between;

        .userBaseInfoContain {
          .infosContain {
            display: flex;
            margin-bottom: 16px;

            &:last-child {
              margin-bottom: 0;
            }

            .label {
              width: 70px;
              flex-shrink: 0;
              color: #666666;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              margin-right: 10px;
            }

            .infoText {
              color: #333333;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              max-width: 600px;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .avatarImg {
              width: 80px;
              height: 80px;
              border-radius: 50%;
            }
          }
        }

        .homeBgContainer {
          margin: 0 100px;

          .userInfoTitleContain {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .userInfoTitle {
              color: #333333;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
            }
          }

          .homeBgContain {
            width: 160px;
            position: relative;
            margin-top: 8px;
            cursor: pointer;

            .homeBg {
              width: 160px;
              height: 90px;
              border-radius: 4px;
              object-fit: cover;
            }

            .imgDelete {
              height: 16px;
              position: absolute;
              top: 0;
              right: 0;
            }
          }

          .homeBgAlert {
            width: 256px;
            color: #999999;
            font-family: "PingFang SC";
            font-size: 12px;
            font-weight: 400;
            line-height: 17px;
            margin-top: 7px;
          }

          .bgAuditStatus {
            color: #f32432;
            font-family: "PingFang SC";
            font-size: 12px;
            font-weight: 400;
            line-height: 17px;
            margin-top: 7px;
          }

          /deep/.uploadElemBox {
            .el-upload-dragger {
              border: 0;
              width: fit-content;
              height: fit-content;
            }

            .el-upload-list {
              display: none;
            }
          }
        }

        .contactContain {
          width: 249px;
          height: 163px;
          border-radius: 8px;
          background: #f6f7fa;
          padding: 3px 0 23px 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          flex-shrink: 0;

          .contactImg {
            height: 64px;
          }

          .contactText {
            color: #333333;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            display: flex;
          }
        }
      }
    }

    .contentSetContain {
      flex: 1;
      border-radius: 8px;
      background: #fff;
      margin-top: 20px;
      padding: 20px 32px 24px 32px;
      overflow-y: hidden;

      .contentSetTitle {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 25px;
      }

      .contentSetAlert {
        color: #999999;
        font-family: "PingFang SC";
        font-size: 10px;
        font-weight: 400;
        line-height: 14px;
        margin-top: 8px;
        margin-bottom: 16px;
      }

      .contentSetInnerContain {
        display: flex;
        height: calc(100% - 63px);

        .menuContain {
          width: 307px;
          height: 100%;
          display: flex;
          flex-direction: column;
          padding-right: 32px;
          border-right: 1px solid #eeeeee;

          .addMenuBtn {
            width: 275px;
            height: 32px;
            border-radius: 4px;
            background-color: #f32432;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .addMenuImg {
              height: 16px;
              margin-right: 8px;
            }

            .addMenuText {
              color: #ffffff;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
            }
          }

          .menusContain {
            flex: 1;
            border-radius: 4px;
            background-color: #f4f5f9;
            padding: 20px;
            margin-top: 20px;
            overflow-y: auto;

            .menuItem {
              border-radius: 8px;
              background: #fff;
              display: flex;
              align-items: center;
              padding: 0 4px 0 12px;
              margin-bottom: 12px;
              cursor: pointer;

              .setImg {
                height: 16px;
                margin-right: 4px;
              }

              .menuName {
                color: #333333;
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 400;
                line-height: 40px;
                flex: 1;
                padding-right: 4px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .menuEditBtn,
              .menuDelBtn {
                color: #999999;
                font-family: "PingFang SC";
                font-size: 12px;
                font-weight: 400;
                margin-right: 8px;
              }

              .acytiveText {
                color: #f32432;
              }
            }

            .active {
              background: #ffe6e6;

              .menuName {
                color: #f32432;
              }
            }
          }
        }

        .menuContentContain {
          flex: 1;
          padding-left: 27px;

          .menuContentTitleContain {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .menuContentTitle {
              color: #333333;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 500;
              line-height: 32px;
            }

            .addNewsBtn {
              width: 100px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 4px;
              background-color: #f32432;
              cursor: pointer;

              .addNewsImg {
                height: 16px;
                margin-right: 4px;
              }

              .addNewsText {
                color: #ffffff;
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 400;
                line-height: 32px;
              }
            }
          }

          .paramsContain {
            .paramInfo {
              color: #666666;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              margin-top: 20px;

              .paramInfoLabel {
                color: #333333;
              }
            }
          }

          .newsContain {
            height: calc(100% - 52px);
            overflow-y: auto;
            margin-top: 20px;
            padding-right: 10px;

            .newsItem {
              padding: 8px 0;
              display: flex;
              height: 110px;
              box-sizing: content-box;
              border-bottom: 1px solid #eeeeee;
              align-items: center;

              &:last-child {
                border-bottom: 0;
              }

              .shiftImg {
                height: 16px;
                margin-right: 20px;
                cursor: pointer;
              }

              .bgContainer {
                width: calc(100% - 29px);
                display: flex;
                padding: 10px;
                border-radius: 5px;
              }

              .cover-container {
                width: 160px;
                height: 90px;
                border-radius: 6px;
                overflow: hidden;
                background: #ccc;
                margin-right: 16px;
                flex-shrink: 0;

                .cover {
                  height: 100%;
                  width: 100%;
                }
              }

              .info-box {
                flex: 1;
                position: relative;
                width: calc(100% - 210px);

                .titleContainer {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 44px;
                }

                .title {
                  flex: 1;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  overflow: hidden;
                  color: #333333;
                  font-family: "PingFang SC";
                  font-size: 18px;
                  font-weight: 500;
                  line-height: 25px;
                  padding-right: 15px;
                }
              }

              .create-time {
                color: #999999;
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
              }

              .action-bar {
                display: flex;
                justify-content: flex-end;

                .countInfo {
                  color: #999999;
                  font-family: "PingFang SC";
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 21px;
                  margin-right: 14px;
                  display: inline-block;
                }

                .menuNewsDelBtn {
                  color: #4876ff;
                  font-family: "PingFang SC";
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 21px;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }

    /deep/.editMenuContainer {
      .el-dialog__body {
        padding-bottom: 32px;
        padding-top: 12px;
        padding-left: 32px;

        .editMenuInnerContain {
          .editItem {
            display: flex;
            align-items: center;
            margin-bottom: 24px;

            .label {
              width: 96px;
              flex-shrink: 0;
              color: #333333;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 500;

              .require {
                color: #f32432;
              }
            }

            .el-input {
              margin-bottom: 0;
            }

            .el-input__inner {
              width: 452px;
              border-radius: 2px;
              background: #f6f7f9;
              border: 0;
              height: 36px;
              color: #333;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
            }
          }
        }
      }

      .submitBtn {
        width: 80px;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        border-radius: 4px;
        color: #333;
        line-height: 36px;
        display: inline-block;
        margin-left: 12px;
      }

      .submitBtn[type="primary"] {
        width: 80px;
        background-color: #ea0e0e;
        border-color: #ea0e0e;
        color: #fff;
      }
    }

    /deep/.collectionAddContainer {
      .el-dialog {
        height: 86vh;

        .el-dialog__body {
          padding-top: 10px;
        }

        .collectionAddKeyword {
          width: 350px;
          margin-bottom: 15px;
        }

        .searchNoDataContainer {
          width: 100%;
          height: calc(86vh - 245px);
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          .noDataText {
            margin-top: 21px;
            font-size: 20px;
            color: rgb(204, 204, 204);
          }
        }

        .videoCollectContainer {
          width: 100%;
          height: calc(86vh - 245px);
          overflow-y: auto;
          padding-right: 10px;

          .scriptListItem {
            padding: 8px 0;
            display: flex;
            height: 110px;
            box-sizing: content-box;
            border-bottom: 1px solid #eeeeee;

            &:last-child {
              border-bottom: 0;
            }

            .el-checkbox {
              margin: 0 10px 0 0;
              display: flex;
              align-items: center;
            }

            .bgContainer {
              width: calc(100% - 29px);
              display: flex;
              padding: 10px;
              border-radius: 5px;
            }

            .cover-container {
              width: 160px;
              height: 90px;
              border-radius: 6px;
              overflow: hidden;
              background: #ccc;
              margin-right: 16px;
              flex-shrink: 0;

              .cover {
                height: 100%;
                width: 100%;
              }
            }

            .info-box {
              flex: 1;
              position: relative;
              width: calc(100% - 210px);

              .titleContainer {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 44px;
              }

              .title {
                flex: 1;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                color: #333333;
                font-family: "PingFang SC";
                font-size: 18px;
                font-weight: 500;
                line-height: 25px;
                padding-right: 15px;
                cursor: pointer;
              }
            }

            .create-time {
              color: #999999;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 21px;
            }

            .action-bar {
              display: flex;

              .countInfo {
                color: #999999;
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                margin-right: 14px;
                display: inline-block;
              }
            }
          }
        }

        .el-dialog__footer {
          margin-top: 10px;
        }
      }
    }

    .rankNoticeContain {
      width: 100%;
      height: 100vh;
      position: fixed;
      top: 0;
      left: 0;
      background: #0000004d;
      display: flex;
      align-items: center;
      justify-content: center;

      .rankNotice {
        width: 338px;
        height: 469px;
        background: url("../../assets/govAffairs/rankBg.png") no-repeat;
        background-size: 100% 100%;
        position: relative;

        .closeImg {
          width: 32px;
          position: absolute;
          top: 0;
          right: -32px;
          cursor: pointer;
        }

        .codeImg {
          width: 80px;
          position: absolute;
          bottom: 41px;
          right: 20px;
        }

        .rankNameContain {
          position: absolute;
          top: 83px;
          left: 0;
          width: 100%;
          height: 150px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .rankItem {
            display: flex;
            align-items: center;
            margin-bottom: 16px;

            &:last-child {
              margin-bottom: 0;
            }

            .nameImg {
              height: 16px;
            }

            .rankName {
              color: #d68e22;
              font-family: "Source Han Sans CN";
              font-size: 14px;
              font-weight: 700;
              line-height: 21px;
              border-bottom: 0.5px solid #d68e22;
              margin: 0 1px;
            }
          }
        }
      }
    }
  }
}
</style>
